import React from 'react';
import { urls } from 'app-constants';
import ObjectTypeFilter from './ObjectTypeFilter';


const TitleTypeFilter = props => <ObjectTypeFilter dataUrl={urls.titleTypes} {...props} />;

export default TitleTypeFilter;
